import React from "react";
import { NavLink } from "react-router-dom";
import { cn } from "../../lib/utils";
import { NAV_ITEMS } from "./Sidebar";
import { Sheet, SheetContent, SheetTitle } from "../ui/sheet";
import { BrandLogo } from "../shared/BrandLogo";

export function MobileNav({ open, onOpenChange }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" data-testid="mobile-nav-drawer">
        <div className="flex h-16 min-h-[64px] items-center gap-2 border-b border-white/10 px-6">
          <SheetTitle asChild>
            <BrandLogo className="h-7" />
          </SheetTitle>
        </div>
        <nav className="flex-1 space-y-1 overflow-y-auto px-3 py-4">
          {NAV_ITEMS.map(({ to, label, icon: Icon, testId }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              onClick={() => onOpenChange(false)}
              data-testid={`mobile-${testId}`}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 rounded-md border-l-2 border-transparent px-3 py-2.5 text-sm font-medium text-white/80 transition-colors hover:bg-primary-hover hover:text-white",
                  isActive && "border-accent bg-primary-hover text-white"
                )
              }
            >
              <Icon size={18} strokeWidth={1.5} />
              <span className="truncate">{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 px-6 py-4 text-[11px] text-white/50">
          The Virsa Tiffin Admin · Phase 3
        </div>
      </SheetContent>
    </Sheet>
  );
}
